import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { RegistMarkService } from './api-services/regist-mark.service';

import { KYMW1503Component } from './kymw1503.component';


/**
 * マーク登録画面 モジュール設定クラス
 *
 * @export KYMW1503Module
 * @class KYMW1503Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1503Component,
  ],
  providers: [
    RegistMarkService,
  ],
})
export class KYMW1503Module {
}
